import ConfirmDialog from '../../components/common/ConfirmDialog';

interface Props {
  productName: string;
  lenderName: string;
  isPending: boolean;
  errorMessage: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  returnFocus: () => void;
}

export default function LenderProductRemoveDialog({ productName, lenderName, isPending, errorMessage, onConfirm, onCancel, returnFocus }: Props) {
  return <ConfirmDialog open appearance="centered" variant="danger" title="Remove Product?"
    message={`${productName} will be removed from ${lenderName}’s catalog.`}
    confirmLabel={isPending ? 'Removing…' : 'Remove Product'} closeLabel="Close removal dialog"
    isPending={isPending} errorMessage={errorMessage} onConfirm={onConfirm} onCancel={onCancel} returnFocus={returnFocus} />;
}
